document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.main-blog');
  if (!root) return;

  var form = root.querySelector('.search-article-form');
  var input = form ? form.querySelector('[data-blog-search-input]') : null;
  var normalWrapper = root.querySelector('.blog-articles__wrapper-normal');
  var searchWrapper = root.querySelector('.blog-articles__wrapper--search');
  var searchList = searchWrapper ? searchWrapper.querySelector('.blog-articles') : null;
  var statusEl = searchWrapper ? searchWrapper.querySelector('.blog-articles__search-status') : null;

  if (!form || !input || !normalWrapper || !searchWrapper || !searchList) return;

  var blogUrl = form.getAttribute('data-blog-url') || '';
  var showImage = form.getAttribute('data-show-image') === 'true';
  var showDate = form.getAttribute('data-show-date') === 'true';
  var showAuthor = form.getAttribute('data-show-author') === 'true';
  var readMoreTemplate = form.getAttribute('data-read-more') || 'Read more: __TITLE__';
  var labelSearching = form.getAttribute('data-label-searching') || '';
  var labelEmpty = form.getAttribute('data-label-empty') || '';
  var labelError = form.getAttribute('data-label-error') || '';
  var articleCache = null;
  var requestId = 0;

  function setStatus(message) {
    if (!statusEl) return;
    if (!message) {
      statusEl.hidden = true;
      statusEl.textContent = '';
      return;
    }
    statusEl.hidden = false;
    statusEl.textContent = message;
  }

  // 清空关键词后回到分页列表，不保留上一次的搜索结果
  function showNormalArticles() {
    requestId += 1;
    normalWrapper.hidden = false;
    searchWrapper.hidden = true;
    searchList.innerHTML = '';
    setStatus('');
  }

  function showSearchArticles() {
    normalWrapper.hidden = true;
    searchWrapper.hidden = false;
  }

  function readMoreLabel(title) {
    return readMoreTemplate.replace('__TITLE__', title || '');
  }

  // 卡片结构和 main-blog-article-card 一致，文本用 textContent，避免把搜索词拼进 HTML
  function createArticleCard(article, index) {
    var item = document.createElement('div');
    item.className = 'blog-articles__article article';

    var card = document.createElement('div');
    card.className = 'main-blog-article-card';

    if (showImage && article.image) {
      var imageWrapper = document.createElement('div');
      imageWrapper.className = 'article__images medium-up--five-tenths';
      var imageLink = document.createElement('a');
      imageLink.href = article.url || '#';
      imageLink.tabIndex = -1;
      imageLink.setAttribute('aria-hidden', 'true');
      var image = document.createElement('img');
      image.src = article.image;
      image.width = article.imageWidth || 800;
      image.height = article.imageHeight || 450;
      image.loading = 'lazy';
      image.alt = '';
      imageLink.appendChild(image);
      imageWrapper.appendChild(imageLink);
      card.appendChild(imageWrapper);
    }

    var content = document.createElement('div');
    content.className = 'article__content';
    var meta = document.createElement('div');
    meta.className = 'article__content-meta';

    if (showDate && article.date) {
      var date = document.createElement('div');
      date.className = 'article__date';
      date.textContent = article.date;
      meta.appendChild(date);
    }

    var title = document.createElement('h2');
    title.className = 'h2 article__title';
    var titleLink = document.createElement('a');
    titleLink.href = article.url || '#';
    titleLink.textContent = article.title || '';
    title.appendChild(titleLink);
    meta.appendChild(title);

    if (showAuthor && article.author) {
      var author = document.createElement('div');
      author.className = 'article__author';
      author.textContent = article.author;
      meta.appendChild(author);
    }

    content.appendChild(meta);

    var desc = document.createElement('div');
    desc.className = 'article__desc';
    // excerptHtml 来自当前博客模板，不是用户输入
    desc.innerHTML = article.excerptHtml || '';
    content.appendChild(desc);

    var more = document.createElement('a');
    more.className = 'article__btn-more';
    more.href = article.url || '#';
    var label = readMoreLabel(article.title || '');
    more.textContent = label;
    more.setAttribute('aria-label', label);
    content.appendChild(more);

    card.appendChild(content);
    item.appendChild(card);
    item.style.setProperty('--animation-order', String(index));
    return item;
  }

  function renderArticles(articles) {
    searchList.innerHTML = '';
    if (!articles.length) {
      setStatus(labelEmpty);
      return;
    }
    setStatus('');
    articles.forEach(function (article, index) {
      searchList.appendChild(createArticleCard(article, index + 1));
    });
  }

  function indexUrl(page) {
    var url = new URL(blogUrl, window.location.origin);
    url.searchParams.set('view', 'tosot-search');
    url.searchParams.set('page', String(page));
    return url.toString();
  }

  // 只请求当前博客的 alternate template，按页拉完再在本地筛选
  function loadArticles() {
    if (articleCache) return Promise.resolve(articleCache);

    return fetch(indexUrl(1), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('blog search index failed');
        return response.json();
      })
      .then(function (firstPage) {
        var pages = firstPage.pages || 1;
        var articles = firstPage.articles || [];
        if (pages <= 1) {
          articleCache = articles;
          return articleCache;
        }

        var rest = [];
        for (var page = 2; page <= pages; page += 1) {
          rest.push(
            fetch(indexUrl(page), { credentials: 'same-origin' }).then(function (response) {
              if (!response.ok) throw new Error('blog search index failed');
              return response.json();
            })
          );
        }

        return Promise.all(rest).then(function (pageData) {
          pageData.forEach(function (data) {
            articles = articles.concat(data.articles || []);
          });
          articleCache = articles;
          return articleCache;
        });
      });
  }

  function countMatches(text, query) {
    if (!text || !query) return 0;
    var count = 0;
    var from = 0;
    while (from < text.length) {
      var index = text.indexOf(query, from);
      if (index === -1) break;
      count += 1;
      from = index + query.length;
    }
    return count;
  }

  // 标题命中优先，其次标签、作者、摘要，只出现在正文里的靠后。
  // 同一档里出现次数多的更靠前；分数相同则保持博客原有的新到旧。
  function relevanceScore(article, query) {
    var title = article.titleText || (article.title || '').toLowerCase();
    var tags = article.tagsText || '';
    var author = article.authorText || '';
    var excerpt = article.excerptText || '';
    var body = article.bodyText || '';
    var score = 0;

    if (title === query) score += 1000;
    else if (title.indexOf(query) === 0) score += 800;
    else if (title.indexOf(query) !== -1) score += 600;

    var titleCount = countMatches(title, query);
    var tagCount = countMatches(tags, query);
    var authorCount = countMatches(author, query);
    var excerptCount = countMatches(excerpt, query);
    var bodyCount = countMatches(body, query);

    score += titleCount * 50;
    if (tagCount) score += 400 + tagCount * 10;
    if (authorCount) score += 300 + authorCount * 10;
    if (excerptCount) score += 200 + excerptCount * 5;
    if (bodyCount) score += 100 + Math.min(bodyCount, 10);

    var titleIndex = title.indexOf(query);
    if (titleIndex > 0) score += Math.max(0, 40 - titleIndex);

    return score;
  }

  function filterArticles(articles, query) {
    return articles
      .map(function (article, index) {
        return {
          article: article,
          index: index,
          score: relevanceScore(article, query),
        };
      })
      .filter(function (item) {
        return item.score > 0;
      })
      .sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        return a.index - b.index;
      })
      .map(function (item) {
        return item.article;
      });
  }

  function runSearch() {
    var query = input.value.trim().toLowerCase();
    if (!query) {
      showNormalArticles();
      return;
    }

    var currentRequest = requestId + 1;
    requestId = currentRequest;
    showSearchArticles();
    searchList.innerHTML = '';
    setStatus(labelSearching);

    loadArticles()
      .then(function (articles) {
        if (currentRequest !== requestId) return;
        renderArticles(filterArticles(articles, query));
      })
      .catch(function () {
        if (currentRequest !== requestId) return;
        articleCache = null;
        searchList.innerHTML = '';
        setStatus(labelError);
      });
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    runSearch();
  });

  // 浏览器搜索框的清空按钮不会提交表单，清空时直接恢复列表
  input.addEventListener('input', function () {
    if (!input.value.trim()) showNormalArticles();
  });
  input.addEventListener('search', function () {
    if (!input.value.trim()) showNormalArticles();
  });
});
